// extracted by mini-css-extract-plugin
export default {"recover__container":"styles_recover__container__-sIz9","recover__links":"styles_recover__links__vVKNv","recover__success":"styles_recover__success__xCGzq"};